import { Collapse, Checkbox, Row, Col, Typography } from "antd";
import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";

//redux
import { selectService } from "../../../../../store/service/service.action";

const { Panel } = Collapse;
const { Text } = Typography;

const SelectService = ({
  group,
  list,
  selected,
  setSelected,
  selectedService,
}) => {
  // -------------------------- VAR --------------------------
  // -------------------------- STATE --------------------------
  const [data, setData] = useState(null);

  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  // -------------------------- FUNCTION --------------------------
  const handleChange = (e) => {
    const service = e.target.value;
    const checked = e.target.checked;
    const name = list?.find((item) => item?.id === service).name;
    const price = list?.find((item) => item?.id === service).price;
    const amount = 1;

    const data = {
      service,
      checked,
      name,
      price,
      amount,
    };

    //Add new when selected dont have
    if (checked) {
      setSelected((selected) => {
        const newData = [...selected, data];
        selectService(dispatch, newData);
        return newData;
      });
    } else {
      const remove = selected?.filter((item) => item?.name !== name);
      setSelected(remove);
      selectService(dispatch, remove);
    }
  };

  // const handleNumberChange = (number, id) => {
  //   const newUpdate = selected.map((obj) =>
  //     obj?.service === id ? { ...obj, amount: number ? number : 0 } : obj
  //   );

  //   setSelected(newUpdate);
  //   // selectService(dispatch, newUpdate);
  // };

  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    if (group) {
      // const sortFormat = lodash.sortBy(group, ["name"]);
      setData(group);
    }
  }, [group]);

  useEffect(() => {
    selectService(dispatch, selected);
  }, [selected, dispatch]);

  // -------------------------- RENDER --------------------------

  const renderItem = (item) => {
    const groupId = item?.id;
    const listItem = list
      ?.filter((row) => row?.group === groupId)
      ?.sort((a, b) => a.order - b.order);
    const checked = selectedService?.map((row) => row.service);
    const newFormat = listItem?.map((item) => {
      const key = item?.id;
      const value = item?.id;
      const name = item?.name;
      const price = item?.price;
      const off = item?.off;
      const from = item?.from || false;
      const old = item?.old || null;

      return {
        key,
        value,
        name,
        price,
        off,
        from,
        old,
      };
    });
    return (
      <Checkbox.Group
        style={{ width: "100%", margin: "-1rem 0rem 0rem 1.5rem" }}
        value={checked}
      >
        {newFormat.map((item) => {
          const off = item?.off || null;
          if (off) {
            return null;
          }

          return (
            <Col style={{ margin: "0.8rem 0rem" }} key={item?.key} span={24}>
              <Row className="checkbox-item">
                <Col span={2}>
                  <Checkbox
                    onChange={handleChange}
                    value={item?.value}
                    // checked={checked}
                  />
                </Col>
                <Col xl={15} lg={15} md={12} sm={12} xs={12}>
                  <Text style={{ width: "100%", whiteSpace: "normal" }}>
                    {item?.name} {item?.from ? "*" : null}
                  </Text>
                </Col>
                <Col
                  xl={5}
                  lg={5}
                  md={8}
                  sm={8}
                  xs={8}
                  style={{ marginLeft: "auto" }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                      whiteSpace: "nowrap", // <-- không cho ngắt dòng số
                    }}
                  >
                    <span>${item?.price}</span>
                    {item?.old && (
                      <Text
                        delete
                        style={{
                          color: "#ff4d4f",
                          textDecorationColor: "#ff4d4f",
                          // optional: làm gạch ngang rõ hơn
                          textDecorationThickness: "2px",
                        }}
                      >
                        ${item.old}
                      </Text>
                    )}
                  </div>
                </Col>
              </Row>
            </Col>
          );
        })}
      </Checkbox.Group>
    );
  };

  // -------------------------- MAIN --------------------------
  return (
    <Collapse defaultActiveKey={["1"]} ghost>
      {data?.map((item) => (
        <Panel key={item?.id} header={item?.name}>
          {renderItem(item)}
        </Panel>
      ))}
    </Collapse>
  );
};

export default SelectService;
